import { useState } from 'react'

import { ModalActionContext, ModalActionsElement } from './ModalActionContext'

/**
 * @deprecated Use ArcadeModalActionProvider
 */
export const ModalActionProvider = ({ children }: { children: React.ReactNode }) => {
  const [actionsOverride, setModalActions] = useState<ModalActionsElement>(undefined)

  return (
    <ModalActionContext.Provider value={{ actions: actionsOverride, setModalActions }}>
      {children}
    </ModalActionContext.Provider>
  )
}
